import { useState, useEffect } from 'react';
import { getVideoUrl } from '../data/videoTemplatesConfig';
import { RedButton } from '../components/common';
import './GeneratePopup.css';

function CloseIcon() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M1 11L11 1" stroke="#FFB2C6" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

function UploadIcon() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path d="M24 32V16M24 16L18 22M24 16L30 22" stroke="#FF537E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 32V36C8 38.2091 9.79086 40 12 40H36C38.2091 40 40 38.2091 40 36V32" stroke="#FF537E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

const popupConfig = {
    subtitle: "Customize persona in this video",
    uploadText: "Add gallery image to replace persona",
    buttonText: "Generate video",
    disclaimers: [
        "You cannot use photos of other people.",
        "You are solely responsible for the images you create.",
        "This website is designed for entertainment purposes only."
    ]
};

export function GeneratePopup({ template, isOpen, onClose, onGenerate }) {
    const [videoLoaded, setVideoLoaded] = useState(false);

    // Reset videoLoaded when template changes
    useEffect(() => {
        setVideoLoaded(false);
    }, [template]);

    // Early return if not open or no template
    if (!isOpen || !template) return null;

    const videoUrl = getVideoUrl(template.video);
    const thumbnailUrl = videoUrl.replace('_small.mp4', '_thumbnail.jpg');

    const handleGenerateClick = () => {
        onGenerate(template.id);
    };

    return (
        <div className="generatePopupOverlay" onClick={onClose}>
            <div className="generatePopupPanel" onClick={e => e.stopPropagation()}>
                {/* Close button */}
                <button className="generatePopupCloseBtn" onClick={onClose}>
                    <CloseIcon />
                </button>

                {/* Header */}
                <div className="generatePopupHeader">
                    <h2 className="generatePopupTitle">{template.title}</h2>
                    <p className="generatePopupSubtitle">{popupConfig.subtitle}</p>
                </div>

                {/* Content: video preview + upload area */}
                <div className="generatePopupContent">
                    <div className="generatePopupPreview">
                        {!videoLoaded && (
                            <img
                                src={thumbnailUrl}
                                alt={template.title}
                                className="generatePopupPreviewMedia"
                            />
                        )}
                        <video
                            src={videoUrl}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="generatePopupPreviewMedia"
                            style={{ display: videoLoaded ? 'block' : 'none' }}
                            onLoadedData={() => setVideoLoaded(true)}
                        />
                    </div>
                    <div className="generatePopupUpload" onClick={handleGenerateClick}>
                        <UploadIcon />
                        <span className="generatePopupUploadText">{popupConfig.uploadText}</span>
                    </div>
                </div>

                {/* Generate button */}
                <div className="generatePopupButtonWrapper">
                    <RedButton onClick={handleGenerateClick}>
                        {popupConfig.buttonText}
                    </RedButton>
                </div>

                {/* Disclaimers */}
                <div className="generatePopupDisclaimers">
                    {popupConfig.disclaimers.map((disclaimer, index) => (
                        <div key={index} className="generatePopupDisclaimer">
                            <span className="generatePopupDisclaimerNumber">{index + 1}.</span>
                            <span>{disclaimer}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default GeneratePopup;
